export default "__VITE_PUBLIC_ASSET__e38e719d__"